// Copyright 2019 Sorama B.V.

import { autoinject, customElement, bindable, bindingMode } from "aurelia-framework";

@customElement("radio-button")
@autoinject
export class RadioButton {
    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public options: unknown[];

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public disabled: boolean;

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public selected: unknown;

    public bind(): void {
        if (!this.selected && this.options && this.options.length > 0) {
            this.selected = this.options[0];
        }
    }
}
